<template>
  <v-container grid-list-md fluid>
      <v-layout row >
          <v-flex md12 >
            <v-card>
            <!--<div class="ibox float-e-margins animated fadeInUp">-->
            <!-- <div class="ibox float-e-margins"> -->
              
              <v-toolbar dense primary-title>
                <v-toolbar-title>{{$t('view.bitacora.filtros.label')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
                  <v-icon>{{ view.elem.showForm ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                </v-btn>
              </v-toolbar>
              <v-slide-y-transition>
                <v-card-text v-show="view.elem.showForm">
                  <v-layout row>
                    <v-flex md12>
                      <v-form role="form">
                        <!-- Skeleton loader -->
                        <div v-if="view.action.submit.busy">
                          <vue-content-loading :width="450" :height="158">
                            <rect x="0" y="0" rx="4" ry="4" width="53" height="10" />
                            <rect x="0" y="15" rx="4" ry="4" width="442" height="34" />
                            <rect x="0" y="64" rx="4" ry="4" width="53" height="10" />
                            <rect x="0" y="79" rx="4" ry="4" width="442" height="34" />
                            <rect x="0" y="128" rx="10" ry="10" width="80" height="30" />
                          </vue-content-loading>
                        </div>
                        <v-layout row>
                          <v-flex md3>
                            <div v-if="!view.action.submit.busy" 
                              v-bind:class="[hasErrors($v.bitacora.comercio)?'has-error':'']">
                              
                              <v-combobox 
                                v-model="$v.bitacora.comercio.$model"
                                :items="view.elem.select.comercio.options"
                                label="Comercio"
                                :error-messages = "$t(`validator.${getFirstError($v.bitacora.comercio)}.text`,'')"
                                item-text="name"
                                item-value="code"
                                :max-height="200" 
                                dense   
                                clearable
                                deletable-chips                           
                                small-chips>
                              </v-combobox>
                              
                            </div>
                          </v-flex>
                          <v-flex md3>
                            <div v-if="!view.action.submit.busy" 
                              v-bind:class="[hasErrors($v.bitacora.tipoArchivo)?'has-error':'']">
                              <v-combobox 
                                v-model="$v.bitacora.tipoArchivo.$model"
                                :items="view.elem.select.tipoArchivo.options"
                                label="Tipo Archivo"
                                :error-messages = "$t(`validator.${getFirstError($v.bitacora.tipoArchivo)}.text`,'')"
                                item-text="name"
                                item-value="code"
                                :max-height="200" 
                                dense
                                clearable
                                deletable-chips                              
                                small-chips>
                              </v-combobox>
                            </div>
                          </v-flex>
                          <v-flex md3 >
                            <div v-if="!view.action.submit.busy" >
                              <v-text-field 
                                      v-model="$v.bitacora.nombreArchivo.$model"
                                      :error-messages="getFirstErrorDescription($v.bitacora.nombreArchivo)"
                                      label="Nombre Archivo" >
                              </v-text-field>
                            </div>
                          </v-flex>
                          <v-flex md3 >
                            <div v-if="!view.action.submit.busy" >
                              <v-dialog
                                ref="dialogInicio"
                                v-model="modalFechaInicio"
                                :return-value.sync="$v.bitacora.fecha.$model"
                                persistent
                                lazy
                                full-width
                                width="290px">
                                <v-text-field
                                  slot="activator"
                                  v-model="formatDateFechaBitacora"
                                  :error-messages = "$t(`validator.${getFirstError($v.bitacora.fecha)}.text`,'')"
                                  label="Fecha"
                                  prepend-icon="event">
                                </v-text-field>
                                <v-date-picker locale="es-ES" v-model="$v.bitacora.fecha.$model" scrollable>
                                  <v-spacer></v-spacer>
                                  <v-btn flat color="primary" @click="modalFechaInicio = false">Cancel</v-btn>
                                  <v-btn flat color="primary" @click="$refs.dialogInicio.save($v.bitacora.fecha.$model)">OK</v-btn>
                                </v-date-picker>
                              </v-dialog>
                            </div>
                          </v-flex>
                          
                          <v-flex md1>
                            <div class="form-group text-center">
                                <v-btn 
                                  @click="submit()" 
                                  color="primary"  dark outline
                                  icon small>
                                  <v-icon>search</v-icon>
                                </v-btn>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-slide-y-transition>
            <!-- </div> -->
            </v-card>
          </v-flex>
      </v-layout>
      <v-layout row >
          <v-flex md12>
            <data-table ref="tableBitacora" 
            @comercioRow="openComercioDetail" 
            @logFileRow="getLogFile" 
            @downloadFileRow="downloadFile" 
            @downloadFileDasRow="downloadFileDas" 
            @uploadDasWithErrorRow="uploadDasWithError"
            @reprocesarRespuesta="reprocesarRespuesta"
            >
            </data-table>
          </v-flex>
      </v-layout>
      <v-layout row >
      <v-flex md12>
        <modal-comercio ref="modalComercio" ></modal-comercio>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import {BitacoraArchivoModel} from "@/models/bitacoras/bitacora-archivo";
import CombosAPI from "@/services/catalogos";
import {required} from "vuelidate/lib/validators";
import {minDateFrom, maxDateFrom} from "@/helpers/vuelidate/validators";
import {allValidatorMethods} from "@/helpers/vuelidate";
import VueContentLoading from 'vue-content-loading';
import DataTable from "@/views/bitacoras/documento/DataTable";
import Multiselect from 'vue-multiselect';
import tippy from 'tippy.js';
import BitacoraArchivoStates from "@/views/bitacoras/documento/archivo-states";
import * as R from "ramda";
import * as dateMethods from "@/helpers/date-methods";
import ModalComercio from "@/views/bitacoras/documento/ModalComercio";
import ComercioAPI from "@/services/generales/comercio";
import ArchivoAPI from "@/services/archivo";
import {getErrors,getBusinessCode,getResponseDTO,handleResponseMessage} from '@/helpers/http-response-handler';
//Element's Settings
const button = {
  submit:{
    enable:true
    , text:""
  }
};
let select = {
  comercio:{
    options:[{name:'', code:''}]
  }
  , tipoArchivo:{
    options:[{name:'', code:''}]
  }
  
  
}
//Action's state
const action = {
  submit:{
    busy:false
  }
};

//Initial Model
//const bitacora = new BitacoraModel();
//Helpers
function evaluateModelChangedMethodResult(data){
  if(!data && typeof data === "boolean"){
  return data
  }

  if(data && typeof data === "object"){
  return data.length>=1;
  } 
}
const modelIsModified = R.curry((model)=>R.compose(evaluateModelChangedFlag,model.changed));

export default {
  name: "BitacoraArchivo",
  head:{
    title:function(){
      return {
        inner       : this.view.title
        , separator : '|'
        , complement: this.$t("view.home.system.initials")
      }
    }
  }
  , data() {
    let _locale = this.$store.language;
    return {
      locale: _locale
      , date: undefined
      , dateFin: undefined
      , bitacora : undefined
      , modalFechaInicio : false
      , modalFechaFin : false
      , form : new Object()
      , view:{
        title:"Bitácora de Archivos"
        , action
        , elem:{
          button
          , select
          , showForm: true
        }
      }
      , check:true
    };
  }
  ,methods: {
    ...allValidatorMethods
    , async submit(){
      try{
        this.$refs.tableBitacora.refreshData();
      }catch(error){
      }
    }
    , async loadBitacora(idBitacora){
      try{
        // const response = await BitacoraAPI.get({clave:idBitacora});
        // console.log(response)
        // const {data:{results:{bitacora}}} = response;
        // Object.setPrototypeOf(this.state, new states.EditingState(this,bitacora));
      }catch(error){
        console.log(error)
      }
    }
    , addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    }
    , getLimitText(){
      return count=> ` y  ${count} más `;
    }
    ,async openComercioDetail(id){
      
      
      try{
        const comercio =  await this.loadComercio(id);
        this.$refs.modalComercio.dialog = true;
        this.$refs.modalComercio.comercio = comercio;
      }catch(e){

      }
      
    }
    , async uploadDasWithError(clave){
      if(this.$userPermission.hasPermission('ROLE_REENVIO_ARCHIVO')){
        try{
          const swalResponse = await this.$swal({
            title: this.$t('view.global.swal.uploadDasWithError.title') , text: this.$t('view.global.swal.uploadDasWithError.text')
            , type: this.$t('view.global.swal.uploadDasWithError.type') , showCancelButton: this.$t('view.global.swal.uploadDasWithError.showCancelButton')
            , confirmButtonColor: this.$t('view.global.swal.uploadDasWithError.confirmButtonColor')
            , cancelButtonColor: this.$t('view.global.swal.uploadDasWithError.cancelButtonColor')
            , confirmButtonText: this.$t('view.global.swal.uploadDasWithError.confirmButtonText')
            , cancelButtonText: this.$t('view.global.swal.uploadDasWithError.cancelButtonText')
            , reverseButtons: true
          });
          if(swalResponse.value){
              const response = await ArchivoAPI.uploadDasWithError({clave});
              handleResponseMessage({ response,modulo:'Archivo'});
              this.$refs.tableBitacora.refreshData();
          }
        }catch(error){
           console.error(error)
        }
      }else{
        EventBus.$emit(events.MESSAGES, {type:'error',message: getErrors('Archivo','No cuenta con privilegios para el reenvío de archivos',null)});
      }
    }
    , async reprocesarRespuesta(clave){
      if(this.$userPermission.hasPermission('ROLE_REPROCESO_RESPUESTA')){
        try{
          const swalResponse = await this.$swal({
            title: this.$t('view.global.swal.rerunResponse.title') 
            , text: this.$t('view.global.swal.rerunResponse.text')
            , type: this.$t('view.global.swal.rerunResponse.type') 
            , showCancelButton: this.$t('view.global.swal.rerunResponse.showCancelButton')
            , confirmButtonColor: this.$t('view.global.swal.rerunResponse.confirmButtonColor')
            , cancelButtonColor: this.$t('view.global.swal.rerunResponse.cancelButtonColor')
            , confirmButtonText: this.$t('view.global.swal.rerunResponse.confirmButtonText')
            , cancelButtonText: this.$t('view.global.swal.rerunResponse.cancelButtonText')
            , reverseButtons: true
          });
          if(swalResponse.value){
              const response = await ArchivoAPI.reprocesarRespuesta({clave});
              handleResponseMessage({ response,modulo:'Archivo'});
              this.$refs.tableBitacora.refreshData();
          }
        }catch(error){
           console.error(error)
        }
      }else{
        EventBus.$emit(events.MESSAGES, {type:'error',message: getErrors('Archivo','No cuenta con privilegios',null)});
      }
    }
    ,async getLogFile(id){
      
      try{
        
        const response = await ArchivoAPI.getLog({clave:id});
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.headers.filename); //or any other extension
        document.body.appendChild(link);
        link.click();
        
        
      }catch(e){
        console.error(e);
      }
     
    }
    , async downloadFile(id){
      const response = await ArchivoAPI.downloadFile({clave:id});
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', response.headers.filename); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
    , async downloadFileDas(id){
      const response = await ArchivoAPI.downloadFileDas({clave:id});
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      //link.cursor="pointer";
      //link.style.cursor="pointer";
      link.setAttribute('download', response.headers.filename); 
      document.body.appendChild(link);
      link.click();
    }
    , async loadComercio(idComercio){
        try{
          
          const respuesta = await ComercioAPI.get({clave:idComercio});
          const responseDTO = getResponseDTO(respuesta);
          return responseDTO.comercio
        }catch(error){
          // console.log(error)
        }
      }
    
  }
  , computed:{
    formatDateFechaBitacora: {
      get() {
        return dateMethods.formatDate(this.$v.bitacora.fecha.$model)
      },
      set(){
        this.$v.bitacora.fecha.$model = null;
      }
    },
  }
  , validations:{
    bitacora:{
      comercio:{
        required:false
      }
      , fecha:{
        required:false
      }
      , tipoArchivo:{
        required:false
      }
      ,nombreArchivo:{
        required:false
      }
    }
  }
  , components: {
    VueContentLoading
    , DataTable
    , Multiselect
    , ModalComercio
  }
  // Instance Lifecycle Hooks
  , async created(){
      this.form = new BitacoraArchivoStates(this);
      this.form.$setState('initial');
  }
  , beforeMount(){
  }
  , mounted(){
    this.$v.$reset();
    // this.$parent.appJQueryConfigMethod();
    this.$nextTick(function(){
      tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/bitacoras/documento/BitacoraArchivo.vue